import { Browser, Version } from "@kakaopay-common/user-agent";
const checkPolicyVersion = () => {
  const currentAppVersion = Browser.getAppVersion();
  if (Browser.isKakaoPayApp()) {
    return Version.isGreaterThanOrEqualTo(currentAppVersion, "2.25.0");
  } else if (Browser.isKakaoTalkApp()) {
    return Version.isGreaterThanOrEqualTo(currentAppVersion, "10.4.5");
  } else {
    return false;
  }
};
const checkNativeStorageVersion = () => {
  const currentAppVersion = Browser.getAppVersion();
  if (Browser.isKakaoPayApp()) {
    return Version.isGreaterThanOrEqualTo(currentAppVersion, "2.22.0");
  } else if (Browser.isKakaoTalkApp()) {
    return Version.isGreaterThanOrEqualTo(currentAppVersion, "10.3.0");
  } else {
    return false;
  }
};
export {
  checkNativeStorageVersion,
  checkPolicyVersion
};
